// Motion gates (plan/03 §5). When either is true, the morph drops to a stepped
// 3-frame sequence (no tweening) and Lenis/parallax stay off.
export function prefersReducedMotion(): boolean {
	return (
		typeof window !== 'undefined' &&
		window.matchMedia?.('(prefers-reduced-motion: reduce)').matches === true
	);
}

export function saveData(): boolean {
	if (typeof navigator === 'undefined') return false;
	const conn = (navigator as unknown as { connection?: { saveData?: boolean } }).connection;
	return conn?.saveData === true;
}

export function motionDisabled(): boolean {
	return prefersReducedMotion() || saveData();
}
